<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <div style="margin-left: auto">
        <el-button
          type="primary"
          @click="sendMessage"
          size="small"
          style="width: 80px"
        >
          <i class="el-icon-position"></i>
          重发
        </el-button>
        <!--        <el-button type="primary" size="small" @click="toggleSelection()" style="width: 100px;">
          <i class="el-icon-close"></i>
          取消选择
        </el-button>-->
      </div>
    </div>

    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="initData"
        class="el-table"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        stripe
        border
        :row-style="{ height: '59px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <el-table-column type="selection" width="55" fixed="left">
        </el-table-column>
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <!--        <el-table-column prop="sentUserName" label="发送人姓名"   align="center" width="120">
        </el-table-column>-->
        <el-table-column
          prop="acceptUserName"
          label="短信接收人"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="certiName"
          label="证书名称"
          align="center"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="certiEndTime"
          label="证书到期时间"
          align="center"
          min-width="130"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <el-table-column
          prop="notice"
          label="短信内容"
          align="center"
          min-width="440"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="success"
          label="发送状态"
          align="center"
          min-width="80"
        >
          <template slot-scope="scope">
            {{ scope.row.success === 1 ? "成功" : "失败" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sendLog"
          label="短信日志"
          align="center"
          min-width="140"
        >
        </el-table-column>
        <el-table-column
          prop="sentTime"
          label="发送时间"
          align="center"
          min-width="130"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <!--        <el-table-column prop="createTime" label="创建时间"   align="center" width="220">
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间"   align="center" width="220">
        </el-table-column>-->
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WlogTotal",
  data() {
    return {
      selectedRows: {}, //选择框
      title: "",
      initData: [], // 存放查询结果
      ListData: [],
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      dialogVisible: false,
    };
  },
  mounted() {
    this.initLog();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // 根据当前选择更新selectedRows
      this.selectedRows = {};
      val.forEach((row) => {
        this.$set(this.selectedRows, this.initData.indexOf(row), true);
      });
      // Handle row selection change if needed
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    sendMessage() {
      const rowsToExport = this.initData.filter(
        (row, index) => this.selectedRows[index]
      );

      // 初始化表单数据
      const formData = new window.FormData();
      const userPhoneList = [];
      const acceptUserNameList = [];
      const certiNameList = [];
      const acceptUserIdList = [];
      const certiIdList = [];

      // 遍历筛选后的行数据，将各字段数据添加到对应的数组中
      rowsToExport.forEach((row) => {
        if (row.phone) {
          userPhoneList.push(row.phone.toString()); // 将 phone 字段转换为字符串并添加到数组中
        } else {
          userPhoneList.push(""); // 如果 phone 为空，则添加空字符串到数组中
        }
        if (row.acceptUserName) {
          acceptUserNameList.push(row.acceptUserName.toString());
        } else {
          acceptUserNameList.push("");
        }
        if (row.certiName) {
          certiNameList.push(row.certiName.toString());
        } else {
          certiNameList.push("");
        }
        if (row.acceptUserId) {
          acceptUserIdList.push(row.acceptUserId.toString());
        } else {
          acceptUserIdList.push("");
        }
        if (row.certiId) {
          certiIdList.push(row.certiId.toString());
        } else {
          certiIdList.push("");
        }
      });
      // 将数组数据添加到表单中
      userPhoneList.forEach((phone) => formData.append("userPhoneList", phone));
      acceptUserNameList.forEach((acceptUserName) =>
        formData.append("acceptUserNameList", acceptUserName)
      );
      certiNameList.forEach((certiName) =>
        formData.append("certiNameList", certiName)
      );
      acceptUserIdList.forEach((acceptUserId) =>
        formData.append("acceptUserIdList", acceptUserId)
      );
      certiIdList.forEach((certiId) => formData.append("certiIdList", certiId));

      // 打印表单数据

      // 发送POST请求
      this.postRequest("/certificate/CertiGroupNote", formData).then((resp) => {
        if (resp) {
          this.dialogVisible = false;
          // this.initCost()
        }
      });

      // for (let i = 0; i < length; i++) { // 循环遍历数组中的每一行数据
      //   const formData = new window.FormData();
      //   // 添加其他表单字段
      //   formData.append('userPhoneList', rowsToExport[i].phone); // 注意这里使用 rowsToExport[i]
      //   formData.append('acceptUserNameList', rowsToExport[i].acceptUserName);
      //   formData.append('certiNameList', rowsToExport[i].certiName);
      //   formData.append('acceptUserIdList', rowsToExport[i].acceptUserId);
      //   formData.append('certiIdList', rowsToExport[i].certiId);
      //   this.postRequest('/certificate/CertiGroupNote', formData).then(resp => {
      //     if (resp) {
      //       this.dialogVisible = false;
      //       // this.initCost()
      //     }
      //   });
      // }
    },

    doChance() {
      this.dialogVisible = false;
      this.initLog();
    },
    showEditView(data) {
      this.dialogVisible = true;
      this.initDataList(data);
      // this.inputObj = data
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initLog();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.initLog();
    },
    initLog() {
      this.loading = true;
      // 使用 inputObj 中的值作为搜索条件
      const searchData = {
        page: this.page,
        limit: this.limit,
      };
      this.getRequests("/certificate/recordlist", searchData).then((resp) => {
        this.loading = false;
        if (resp) {
          this.initData = resp.data; // 将数据赋值给 initData
          this.total = resp.total;
        }
      });
    },
  },
};
</script>

<style>
</style>
